module.exports = __webpack_public_path__ + "media/img/frontend_application/content_production/client_14-74726ca3972875aefdf7f262a6ac8446.png";